import React from 'react';
import { useTranslation } from 'react-i18next';
import { BankInfo } from '../../components/BankInfo';
import { Layout } from '../../components/onvista/Layout';
import { BigCallToAction } from '../../features/landingMain/CallToAction';
import { colors } from '../../plugins/material-ui/themes/onvistaTheme';

export default () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <BankInfo
        bankSlug="dab"
        title={t(`banks.dab.title`, { ns: 'onvista' })}
        calculatorUrl="/onvista-cashback#detail-calculator-with-header"
      />
      <BigCallToAction
        buttonColor={colors.ovMagenta}
        buttonFontColor={colors.white}
        buttonLinkAttributes="mandator=onvista-cashback"
      />
    </Layout>
  );
};
